import { CommonModule, NgComponentOutlet } from '@angular/common';
import { Component, Injector, Input, OnInit, resolveForwardRef, TemplateRef, ViewChild } from '@angular/core';
import { SelectWidget } from '@app/finxone-web-frontend/app/lib/actions/grid.action';
import { getComponentByLabel } from '@app/finxone-web-frontend/app/lib/utils/get-component.utils';
import { createChildWidgetInjector } from '@app/finxone-web-frontend/app/Modules/zones/utils';
import { ChildComponentList } from '@app/finxone-web-frontend/app/Modules/zones/widget-layout/main-widget/main-widget.component';
import { ComponentInjectorConfig } from '@app/finxone-web-frontend/app/Modules/zones/widget-layout/widget-layout.service';
import { getWidgetClasses } from '@app/finxone-web-frontend/app/widget.utis';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  BaseCssConfig,
  isLayoutWidget,
  NewUiZoneWidgetConfig,
  ProviderClass,
  UiZoneWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { EmblaOptionsType } from 'embla-carousel/components/Options';
import { Subject } from 'rxjs';
import { CarouselComponent, CarouselSlide } from '../carousel/carousel.component';

export interface LayoutSlide {
  components: ComponentInjectorConfig[];
}

@Component({
  selector: 'finxone-web-frontend-layout-driven-carousel',
  templateUrl: './layout-driven-carousel.component.html',
  standalone: true,
  imports: [CommonModule, NgComponentOutlet, CarouselComponent],
})
export class layoutDrivenCarouselComponent implements OnInit {
  @AutoDestroy destroy$ = new Subject<void>();
  @ViewChild('layoutSlide', { static: true }) layoutSlide!: TemplateRef<any>;
  @Input() carouselConfig = {};
  @Input() isWorkflow: boolean;
  @Input() baseCssConfig: BaseCssConfig;
  @Input() carouselSlideConfigs: { [key: string]: string }[] = [];
  @Input() emblaOptions: EmblaOptionsType = {};
  @Input() carouselStyle: { [key: string]: any } = {};
  @Input() carouselSlidesContainerStyle = {};
  public widgetConfig: UiZoneWidgetConfig;
  public slides: CarouselSlide[] = [];
  public mouseOver = '';
  public mouseOverId = '';

  constructor(
    public childComponents: ChildComponentList,
    private dataIn: ProviderClass<any>,
    private injector: Injector,
    private store: Store,
  ) {
    if (this.dataIn != null) {
      this.widgetConfig = this.dataIn.widgetConfig;
    }
  }

  ngOnInit(): void {
    this.mapWidgetsToSlides();
  }

  private mapWidgetsToSlides(): void {
    if (!Array.isArray(this.childComponents?.list)) return;

    this.slides = (this.childComponents.list as any[][]).map(
      (slideWidgets): CarouselSlide => ({
        components: slideWidgets.map(
          (widget): ComponentInjectorConfig => ({
            component: resolveForwardRef(getComponentByLabel(widget.name)),
            injector: createChildWidgetInjector(
              widget,
              this.injector,
              this.dataIn,
              isLayoutWidget(widget.name)
                ? [
                    {
                      provide: ChildComponentList,
                      useValue: new ChildComponentList(widget.childComponents ?? []),
                    },
                  ]
                : [],
            ),
            widget: widget,
          }),
        ),
      }),
    );
  }

  public getWidgetClasses = getWidgetClasses;

  public selectWidget(event: MouseEvent, widget: NewUiZoneWidgetConfig) {
    if (this.isWorkflow) {
      if (event.shiftKey) {
        this.store.dispatch(new SelectWidget(widget.uniqueId.toString(), true));
      } else {
        this.store.dispatch(new SelectWidget(widget.uniqueId.toString(), false));
      }
    }
    event.stopPropagation();
  }

  public changeStyle($event: any, mouseOverId?: string) {
    this.mouseOver = $event.type == 'mouseover' ? 'widget-hover' : '';
    if (mouseOverId) this.mouseOverId = mouseOverId;
    $event.stopPropagation();
  }
}
